<div
  style="position: absolute; gap: 142px; height: 49px"
  class="flag-managing flex d-flex justify-content-between"
  *ngIf="hasSelectedFlags && !managingGroups">
  <div style="display: flex; align-items: center">
    <h3
      style="
        font-size: 14px;
        margin: 0;
        padding: 8px 0;
        font-family: Lato;
        font-weight: 500;
        font-style: normal;
        color: #111010;
      ">
      Flags selected: {{ selectedCount }}
    </h3>
    <button class="btn btn-link" style="flex: none; line-height: 1; padding: 8px 16px">
      <span (click)="onSelectAll()">Select all</span>/<span (click)="unSelectAll()">Deselect all</span>
    </button>
  </div>

  <div class="d-flex">
    <div *ngIf="!changeStatus" class="d-flex" style="width: fit-content; text-align: end; gap: 2px">
      <button
        class="btn btn-aru-icon group-flag"
        [disabled]="!canGroupFlags()"
        (click)="onGroupFlags()"
        *ngIf="!selectedGroup">
        <img style="padding-top: 0px" src="assets/img/link.svg" alt="" />
        <span>Group flags</span>
      </button>

      <button class="btn btn-aru-icon group-flag" (click)="onShowGroupTemplate()" *ngIf="!selectedGroup">
        <img style="padding-top: 0px" src="assets/img/svg/group-template.svg" alt="" />
        <span>Group template</span>
      </button>
      <button class="btn btn-aru-icon group-flag" (click)="onUngroupFlags()" *ngIf="selectedGroup">
        <img style="padding-top: 0px" src="assets/img/link.svg" alt="" />
        <span>Unlink flags</span>
      </button>

      <button
        class="btn btn-aru-icon group-flag"
        (click)="onExtensionGrantedDeadlines()"
        [disabled]="hasNonDiscrepancyFlag()"
        *ngIf="selectedGroup && !allSelectedAreExcluded() && (underwritingStatus == '3' || underwritingStatus == '4')"
        style="max-width: 175px; text-wrap: nowrap">
        <img src="assets/img/svg/grant-extension.svg" alt="" style="width: 16px; height: 16px; padding-top: 0px" />
        Grant Extension
      </button>
      <button
        class="btn btn-aru custom-button btn-hover"
        [class.spacing-right]="shouldShowResolveOptions || selectedTab == 'resolved'"
        (click)="onIgnoreFlags()"
        *ngIf="!allSelectedAreExcluded() && !!selectedGroup">
        Exclude
      </button>
      <button
        class="btn btn-aru custom-button btn-hover"
        [class.spacing-right]="shouldShowResolveOptions || selectedTab == 'resolved'"
        (click)="onKeepFlags()"
        *ngIf="allSelectedAreExcluded() && !!selectedGroup">
        Include
      </button>
    </div>
    <div
      *ngIf="shouldShowResolveOptions || selectedTab == 'resolved'"
      class="d-flex"
      style="width: fit-content; text-align: end; gap: 16px">
      <button
        *ngIf="resolveBarSelectedTab === 'partial' || selectedTab == 'resolved'"
        type="button"
        (click)="onChangeFlagStatusBulk(FlagStatus.UNRESOLVED)"
        class="btn btn-aru custom-button unresolved-btn">
        Unresolved
      </button>
      <button
        *ngIf="resolveBarSelectedTab === 'unresolved' || selectedTab == 'resolved'"
        type="button"
        (click)="onChangeFlagStatusBulk(FlagStatus.PARTIAL_RESPONSE)"
        class="btn btn-aru custom-button partial-response-btn">
        Partial response
      </button>
      <button
        *ngIf="shouldShowResolveOptions"
        [disabled]="loading"
        type="button"
        class="btn btn-aru custom-button resolved-btn"
        (click)="onChangeFlagStatusBulk(FlagStatus.RESOLVED); $event.stopPropagation()">
        Resolved
      </button>
    </div>

    <div class="cross" (click)="unSelectAll()">
      <img style="height: 24px; width: 24px" src="assets/img/x.svg" alt="" />
    </div>
  </div>
</div>

<app-group-name-modal
  #groupNameModal
  (createGroup)="onGroupNameProceed($event)"
  (mergeInGroup)="onMergeInGroupProceed($event)"></app-group-name-modal>

<app-extension-granted-deadlines
  #extensionModal
  [selectedFlags]="selectedFlags"
  (deadlinesUpdated)="extensionGrantedDeadlines.emit()">
</app-extension-granted-deadlines>
